export const navData = () => {
  return [
    {
      anchor: "#FeaturedProject",
      title: "Featured",
    },
    {
      anchor: "#ProjectCarousel",
      title: "More Projects",
    },
    // {
    //   anchor: "#Contact",
    //   title: "Contact Me",
    // },
  ];
};
